import React from 'react'

type CodeSheetStatusBannerVariant = 'info' | 'success' | 'warning' | 'error'

type CodeSheetStatusBannerProps = {
  children: React.ReactNode
  action?: React.ReactNode
  testId?: string
  variant?: CodeSheetStatusBannerVariant
}

const VARIANT_CLASSES: Record<CodeSheetStatusBannerVariant, { root: string; marker: string }> = {
  info: {
    root: 'border-[#D8E4F0] bg-[#F2F6F9] text-[#1D5176]',
    marker: 'border-[#5F7284]',
  },
  success: {
    root: 'border-[#BEE4C9] bg-[#EAF7EE] text-[#1E7A3F]',
    marker: 'border-[#1E7A3F]',
  },
  warning: {
    root: 'border-[#F6D79A] bg-[#FFF7E8] text-[#8A5A00]',
    marker: 'border-[#B7791F]',
  },
  error: {
    root: 'border-[#F3C2BE] bg-[#FFF5F5] text-[#B3261E]',
    marker: 'border-[#B3261E]',
  },
}

export default function CodeSheetStatusBanner({
  children,
  action,
  testId,
  variant = 'info',
}: CodeSheetStatusBannerProps) {
  const variantClasses = VARIANT_CLASSES[variant]

  return (
    <div
      data-testid={testId}
      className={`flex w-full flex-wrap items-center justify-between gap-3 border-y px-6 py-3 text-left text-sm ${variantClasses.root}`}
    >
      <div className="flex min-w-0 items-center gap-2">
        <span className={`h-4 w-4 shrink-0 rounded-full border-2 ${variantClasses.marker}`} aria-hidden="true" />
        <div className="min-w-0">{children}</div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
